import { InfoCircleOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import React, { useState } from 'react';

import CostPerKmStatsModal from '../modals/CostPerKmStatsModal';

interface CostPerKmStatsWidgetProps {
  carrierId: number | null | undefined;
  carrierName?: string;
}

const CostPerKmStatsWidget: React.FC<CostPerKmStatsWidgetProps> = ({
  carrierId,
  carrierName,
}) => {
  const [modalOpen, setModalOpen] = useState(false);

  if (!carrierId) {
    return null;
  }

  return (
    <>
      <Button icon={<InfoCircleOutlined />} onClick={() => setModalOpen(true)}>
        Cost/KM Stats
      </Button>
      <CostPerKmStatsModal
        carrierId={carrierId}
        carrierName={carrierName}
        open={modalOpen}
        onClose={() => setModalOpen(false)}
      />
    </>
  );
};

export default CostPerKmStatsWidget;
